var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container py-3" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
        _c(
          "div",
          { staticClass: "py-3" },
          [
            _c(
              "router-link",
              { staticClass: "text-primary-link", attrs: { to: "/rewards" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.rewards.title")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.rewards.points_history")) +
                "\n      "
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.userPoints && _vm.userPoints.length > 0
          ? _c(
              "section",
              { staticClass: "mt-3" },
              [
                _vm._l(_vm.userPoints, function(userPoint, index) {
                  return _c("div", { key: _vm.userPoints }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex row align-items-center text-secondary"
                      },
                      [
                        userPoint.point_action_type
                          ? _c("div", { staticClass: "flex-fill" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("multiLangName")(
                                      userPoint.point_action_type
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-right flex-fill text-small" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("prettyDate")(userPoint.created_at)
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex row" }, [
                      _c("div", { staticClass: "flex-grow-1" }, [
                        _c("div", [
                          userPoint.point_type === "acquired" && userPoint.order
                            ? _c("label", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$options.filters.serviceParentName(
                                        userPoint.order.service_id,
                                        _vm.globalState.services
                                      )
                                    )
                                  }
                                }),
                                _vm._v(
                                  "\n                  #" +
                                    _vm._s(userPoint.order.order_code) +
                                    "\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          userPoint.point_type === "used" && userPoint.reward
                            ? _c("label", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$i18n.locale === "th"
                                        ? userPoint.reward.title_th
                                        : userPoint.reward.title_en
                                    ) +
                                    "\n                "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-small text-secondary" }),
                        _vm._v(" "),
                        userPoint.point_type === "acquired"
                          ? _c(
                              "div",
                              { staticClass: "text-small text-secondary pt-2" },
                              [
                                userPoint.is_expired && userPoint.is_used == 0
                                  ? _c("span", [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-exclamation-triangle -status-pending"
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.rewards.points_expired_date"
                                            )
                                          ) +
                                          "\n                  " +
                                          _vm._s(
                                            _vm._f("prettyOnlyDate")(
                                              userPoint.expire_date
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : !userPoint.is_expired
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.rewards.points_will_expire_date"
                                            )
                                          ) +
                                          "\n                  " +
                                          _vm._s(
                                            _vm._f("prettyOnlyDate")(
                                              userPoint.expire_date
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "align-self-center" }, [
                        userPoint.point_type === "acquired"
                          ? _c(
                              "span",
                              {
                                class: [
                                  userPoint.is_expired && userPoint.is_used == 0
                                    ? "text-secondary"
                                    : "-status-new"
                                ]
                              },
                              [
                                _c("i", { staticClass: "fal fa-plus" }),
                                _vm._v(
                                  _vm._s(
                                    _vm._f("prettyNumber")(userPoint.points)
                                  )
                                )
                              ]
                            )
                          : userPoint.point_type === "used"
                          ? _c("span", { staticClass: "-status-alert" }, [
                              _c("i", { staticClass: "fal fa-minus" }),
                              _vm._v(
                                _vm._s(
                                  _vm._f("prettyNumber")(userPoint.points)
                                ) + "\n              "
                              )
                            ])
                          : userPoint.point_type === "expired"
                          ? _c("span", { staticClass: "text-secondary" }, [
                              _c("i", { staticClass: "fal fa-minus" }),
                              _vm._v(
                                _vm._s(
                                  _vm._f("prettyNumber")(userPoint.points)
                                ) + "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr")
                  ])
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-center" }, [
                  _vm.isMore
                    ? _c(
                        "button",
                        {
                          staticClass: "button -cyan",
                          attrs: { disabled: _vm.isFetching },
                          on: {
                            click: function($event) {
                              return _vm.fetchMore()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isFetching
                                  ? _vm.$t("message.button.loading")
                                  : _vm.$t("message.button.load_more")
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ],
              2
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39a0d6a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a0d6a4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/UserPoints.vue
// module id = 2300
// module chunks = 0